import { render, staticRenderFns } from "./AbsentStudent.vue?vue&type=template&id=10d9381e&"
import script from "./AbsentStudent.vue?vue&type=script&lang=js&"
export * from "./AbsentStudent.vue?vue&type=script&lang=js&"
import style0 from "./AbsentStudent.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports